import { configureStore } from "@reduxjs/toolkit";
import authSlice from "./slices/auth.slice";
import enumsSlice from "./slices/enums.slice";
import incidentAlertsSlice from "./slices/incidentAlerts.slice";

export const store = configureStore({
  reducer: {
    auth: authSlice.reducer,
    // module: moduleSlice.reducer,
    // companySettings: companySettingsSlice.reducer,
    enums: enumsSlice.reducer,
    incidentAlerts: incidentAlertsSlice.reducer,
  },
});

export class StoreKeeper {
  public static store: typeof store;
}

export type RootState = ReturnType<typeof store.getState>;
StoreKeeper.store = store;
